import React from 'react'
import renderHTML from 'react-html-parser'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

import useVendor from '~/hooks/use-vendor'
import Overlay from '~/truck/overlay'
import theme from '~/truck/theme'

import Modal from '../modal'
import Wysiwyg from '../wysiwyg'

const StyledModal = styled(Modal.Standalone)`
  align-items: center;
  height: auto;
  justify-content: center;
  overflow-y: hidden;
  padding: ${theme.spacing.cozy * 5}px;
  padding-bottom: ${theme.spacing.cozy * 4}px;

  ${up('lg')} {
    padding: ${theme.spacing.cozy * 10}px;
    padding-bottom: ${theme.spacing.cozy * 9}px;
  }
`

const StyledOverlay = styled(Overlay)`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 0 ${theme.spacing.comfortable}px;
`

function UnderConstructionModal() {
  const vendor = useVendor()

  return (
    <StyledOverlay open>
      <StyledModal>
        <Wysiwyg />
        <div className="wysiwyg">{renderHTML(vendor.settings.underConstructionContent)}</div>
      </StyledModal>
    </StyledOverlay>
  )
}

export default UnderConstructionModal
